//- セルが選択されたときのインディケータ
orders-planner-line-ui-ind-cell
  .cell(if="{ this.isShow }" style="left: {this.left}px")
  script(type="typescript").
    this.mixin('orders.planner.line-ui.ind-cell');
